const faqs = [
  {
    q: '小草影院需要注册才能看电影吗？',
    a: '不需要注册。小草影院的影片资源全部免费开放，打开网站即可直接浏览和观看，无需任何注册或登录步骤。',
  },
  {
    q: '影片画质怎么样？支持高清播放吗？',
    a: '小草影院提供高清画质的影片播放体验，大部分影片支持 1080P 清晰度，部分热门院线大片可达到超清画质，确保您获得流畅且清晰的观影体验。',
  },
  {
    q: '小草影院的影片更新频率如何？',
    a: '小草影院片库每日更新，平均每天新增 30 部以上影片。最新上映的院线大片、热门动作片和喜剧电影都会第一时间上架，确保您不会错过任何精彩内容。',
  },
  {
    q: '可以在手机上观看小草影院吗？',
    a: '可以的。小草影院全面适配手机、平板和电脑端，无论您使用什么设备访问，都能获得良好的浏览和观影体验。',
  },
  {
    q: '小草影院有广告吗？观影过程中会中断吗？',
    a: '小草影院尽最大努力减少广告干扰，观影过程中不会插入中断广告，确保您能沉浸式地享受电影。我们有完善的片源优化机制，提供流畅的播放体验。',
  },
  {
    q: '如果我想看的电影没有找到怎么办？',
    a: '您可以通过联系我们页面提交影片需求。我们的内容团队会优先处理用户推荐的热门影片，尽快将其加入片库中供大家观看。',
  },
];

export default function FAQSection() {
  return (
    <section id="faq" className="py-14 md:py-20 px-4 md:px-6 bg-background-100">
      <div className="max-w-4xl mx-auto">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-900 font-heading mb-3">
            常见问题
          </h2>
          <p className="text-sm text-foreground-600 max-w-lg mx-auto">
            关于小草影院的使用，这里有一些常见问题的解答
          </p>
        </div>

        <div className="space-y-3">
          {faqs.map((faq, i) => (
            <div
              key={i}
              className="bg-background-50 rounded-xl p-5 md:p-6 border border-background-200/70"
            >
              <h3 className="text-base font-semibold text-foreground-900 mb-2 font-heading flex items-start gap-3">
                <span className="flex-shrink-0 w-6 h-6 flex items-center justify-center rounded-full bg-primary-100 text-primary-600 text-xs font-bold mt-0.5">
                  Q
                </span>
                {faq.q}
              </h3>
              <p className="text-sm text-foreground-600 leading-relaxed pl-9">{faq.a}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}